import styled, { css } from 'styled-components';
import Text from '@components/text';
import Section from '@components/section';
import LinkComponent from '@components/link';

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Container = styled.div<{ $enclosedContainer?: boolean }>`
  ${({ theme }) => css`
    margin: 0 auto;
    padding: 6rem 3rem;
    display: flex;
    justify-content: center;
    background-color: ${theme.colors.secondary};
    border-radius: ${theme.borderRadius.large};

    @media (max-width: ${theme.breakpoints.lg}) {
      padding: ${theme.padding.cards.md};
    }

    @media (max-width: ${theme.breakpoints.md}) {
      padding: ${theme.padding.cards.sm};
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      padding: 2.5rem 1rem;
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    max-width: 768px;

    @media (max-width: ${theme.breakpoints.xxl}) {
      max-width: 768px;
    }

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      max-width: 768px;
    }

    @media (max-width: ${theme.breakpoints.lg}) {
      max-width: 720px;
    }

    @media (max-width: ${theme.breakpoints.md}) {
      max-width: 540px;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      align-items: flex-start;
      text-align: left;
      max-width: 100%;
    }
  `}
`;

export const LinkButton = styled(LinkComponent)`
  ${({ theme }) => css`
    margin: 1rem 0 auto;
    background-color: ${theme.colors.white};
    color: ${theme.colors.black};
    transition: transform 0.3s ease-in-out;

    &:hover {
      transform: scale(1.0625);
      background-color: ${theme.colors.primary};
      color: ${theme.colors.white};
      transform: scale(1.0625);

      svg {
        fill: ${theme.colors.secondary};
        stroke: ${theme.colors.secondary};
      }
    }
    &:active {
      transform: scale(0.9375);
    }
  `}
`;

export const StyledText = styled(Text)`
  ${({ theme }) => css`
    display: block;
    margin-bottom: ${theme.spacing.md};
  `}
`;

export const StyledSection = styled(Section)`
  ${({ theme, backgroundColor }) => css`
    padding-bottom: 0;

    &::after {
      content: '';
      display: block;
      height: 50%;
      background-color: ${backgroundColor === 'white'
        ? theme.backgroundColors.light
        : theme.backgroundColors.white};
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 0;
    }
  `}
`;
